import React from 'react';
import FormEdit from '../../../components/common/Forms/FormEdit';

/**
 * ConstFormEdit - Page wrapper for editing filled Construction forms
 * Used for navigation in routes/index.tsx
 */
const ConstFormEdit: React.FC = () => {
  return <FormEdit />;
};

export default ConstFormEdit;
